import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withSizes } from 'react-sizes';
import Cookie from 'js-cookie';
import Link from 'next/link';
import BookingPanel from '../../containers/BookingPanel';
import {
  StepInstructions,
  BookingWhatYouGet,
  BookingDiscount,
  TagOnInstagram,
  StatusMessage,
  BookingHotelInfo,
  HotelAmenitiesSection,
} from '../index';

import {
  BookingAccessPass,
  ShareBooking,
  ManageBooking,
} from '../../containers';
import {
  slugify,
} from '../../utils';

import {
  BookingContainer,
  BookingWrapper,
  BookingHeader,
  BookingHeading,
  BookingTwoColumn,
  MyAccountButton,
  NavigateToAccountContainer,
  NavigateToAccountHeading,
  NavigateToAccountText,
} from './styles';

const { BookingPanelContainer, BookingInfo, HotelInfo, PaymentInfo, BookingDivider } = BookingPanel;

const mapSizesToProps = ({ width }) => ({
  isTablet: width >= 768,
});

const mapStateToProps = state => ({
  passwordUpdateIsSuccessful: state.user.success.updatePassword,
  status: state.bookingManagement.hotel.status,
  userData: state.user.userData,
  currManagingBooking: state.bookingManagement.hotel,
  promoData: state.bookingManagement.hotel.promocodeData,
});

@withSizes(mapSizesToProps)
@connect(mapStateToProps)
class BookingPageLayout extends Component {
  static propTypes = {
    isTablet: PropTypes.bool,
    booking: PropTypes.instanceOf(Object),
    hotel: PropTypes.instanceOf(Object),
    payment: PropTypes.instanceOf(Object),
    status: PropTypes.number,
    passwordUpdateIsSuccessful: PropTypes.bool,
    userData: PropTypes.instanceOf(Object),
    currManagingBooking: PropTypes.instanceOf(Object),
    promoData: PropTypes.instanceOf(Object),
  };

  constructor(props) {
    super(props);
    const { booking } = props;
    this.state = {
      newUser: false,
      booking,
    };
  }

  componentDidMount() {
    const newUser = Cookie.get('new') || 'false';

    this.setState({
      newUser: JSON.parse(newUser),
    })
  }

  componentDidUpdate() {
    const { currManagingBooking: newCurrManagingBooking } = this.props;
    const { booking } = this.state;

    if (booking.status !== newCurrManagingBooking.status || booking.checkinDate !== newCurrManagingBooking.checkinDate) {
      this.setState({
        booking: {
          ...booking,
          ...newCurrManagingBooking
        }
      })
    }
  };

  render() {
    const { newUser, booking } = this.state;
    const { isTablet, hotel, payment, passwordUpdateIsSuccessful, status, userData, promoData } = this.props;
    const {
      guestName,
      bookingId,
      bookingCode,
      checkinDate,
      date,
      expiration,
      guestAmount,
      productAmount,
      productName,
      productType,
      productPrice,
      promoCode,
      promoDisclaimer,
      promoPercent,
      whatYouGet,
      productId,
      redeemedDate,
      canceledDate,
      freeProductAmount,
    } = booking;
    const {
      timeZone,
      address,
      amenities,
      checkin,
      hotelName,
      isKidAllowed,
      parking,
      photos,
      rating,
      totalReviews,
      workingHours,
      marketName,
      hotelId,
    } = hotel;

    const productUrl = `/l/${slugify(marketName)}/${slugify(hotelName)}-${slugify(productName)}?hid=${hotelId}&pid=${productId}`;

    const { street, neighborhood, state, zipCode } = address;

    const { credit, paidBy, tax, totalPrice, paymentFee } = payment;

    return (
      <BookingContainer>
        <BookingWrapper withUser={newUser && !passwordUpdateIsSuccessful || newUser && userData && passwordUpdateIsSuccessful}>
          <BookingHeader>
            <BookingHeading>Booking</BookingHeading>
            {isTablet && (
              <ManageBooking
                productName={productName}
                hotelName={hotelName}
                checkinDate={checkinDate}
                address={`${street} ${neighborhood} ${state}, ${zipCode}`}
                status={status}
              />
            )}
          </BookingHeader>
          {isTablet && (
            <BookingPanelContainer bookingId={bookingId} status={status}>
              <BookingInfo
                guestName={guestName}
                guestAmount={guestAmount}
                date={checkinDate}
                productAmount={productAmount}
                productType={productType}
                status={status}
                expiration={expiration}
                timeZone={timeZone}
                redeemedDate={redeemedDate}
                canceledDate={canceledDate}
              />
              <HotelInfo
                checkIn={checkin}
                isKidAllowed={isKidAllowed}
                parking={parking}
                workingHours={workingHours}
              />
              <BookingDivider />
              <PaymentInfo
                productAmount={Number(productAmount) - Number(freeProductAmount)}
                bookingDate={date}
                paymentFee={paymentFee}
                credit={credit}
                paidBy={paidBy}
                checkinDate={checkinDate}
                price={productPrice}
                promo={promoData}
                tax={tax}
                total={totalPrice}
                bookingId={bookingCode}
                productType={productType}
                status={status}
                freeProductAmount={freeProductAmount}
                isTablet
              />
            </BookingPanelContainer>
          )}
          {isTablet && <StatusMessage status={status}  booking={booking} userData={userData} hotel={hotel}/>}
          {!isTablet && (
            <BookingHotelInfo
              address={`${street} ${neighborhood} ${state}, ${zipCode}`}
              productName={productName}
              hotelName={hotelName}
              rating={rating}
              totalReviews={totalReviews}
              photos={photos.slice(0, 3)}
            />
          )}
          {!isTablet && (
            <BookingInfo
              guestName={guestName}
              guestAmount={guestAmount}
              date={checkinDate}
              productAmount={productAmount}
              productType={productType}
              status={status}
              expiration={expiration}
              timeZone={timeZone}
              redeemedDate={redeemedDate}
              canceledDate={canceledDate}
            />
          )}
          {isTablet && newUser && !passwordUpdateIsSuccessful && <BookingAccessPass />}
          {newUser && userData && passwordUpdateIsSuccessful && (
            <NavigateToAccountContainer>
              <NavigateToAccountHeading>Access booking in future</NavigateToAccountHeading>
              <NavigateToAccountText>Success! Your account has been created. You can now access your day passes through your account.</NavigateToAccountText>
              <Link href='/my-account'>
                <MyAccountButton as="a" btnType="secondary">My Account</MyAccountButton>
              </Link>
            </NavigateToAccountContainer>
          )}
          <StepInstructions steps={['Access your booking on your mobile phone', 'Show your booking and photo ID', 'Hotel will validate']} heading='Check-in Instructions' />
          {!isTablet && (
            <HotelInfo
              checkIn={checkin}
              isKidAllowed={isKidAllowed}
              parking={parking}
              workingHours={workingHours}
            />
          )}
          {isTablet && (
            <BookingHotelInfo
              address={`${street} ${neighborhood} ${state}, ${zipCode}`}
              productName={productName}
              hotelName={hotelName}
              rating={rating}
              totalReviews={totalReviews}
              photos={photos.slice(0, 3)}
            />
          )}
          <ShareBooking productUrl={productUrl} productName={productName} hotelName={hotelName} neighborhood={neighborhood} bookingId={bookingId} photo={photos[0]} />
          {whatYouGet && <BookingWhatYouGet>{whatYouGet}</BookingWhatYouGet>}
          {promoCode && (
            <BookingDiscount
              code={promoCode}
              percent={promoPercent}
              description={promoDisclaimer}
              twoColumn={!whatYouGet}
            />
          )}
          {!isTablet && (
            <ManageBooking
              bookingId={bookingId}
              hotelPicture={photos[0]}
              productName={productName}
              neighborhood={neighborhood}
              hotelName={hotelName}
              price={totalPrice / 100}
              checkinDate={expiration}
              address={`${street} ${neighborhood} ${state}, ${zipCode}`}
              status={status}
            />
          )}
          {!isTablet && newUser && !passwordUpdateIsSuccessful && <BookingAccessPass />}
          {isTablet && amenities && (
            <BookingTwoColumn>
              <HotelAmenitiesSection amenities={amenities} />
            </BookingTwoColumn>
          )}
          <TagOnInstagram />
          {!isTablet && <StatusMessage status={status} booking={booking} userData={userData}/>}
          {!isTablet && (
            <PaymentInfo
              productAmount={Number(productAmount) - Number(freeProductAmount)}
              bookingDate={date}
              credit={credit}
              paidBy={paidBy}
              paymentFee={paymentFee}
              price={productPrice}
              promo={promoData}
              tax={tax}
              total={totalPrice}
              bookingId={bookingCode}
              productType={productType}
              status={status}
              freeProductAmount={freeProductAmount}
            />
          )}
        </BookingWrapper>
      </BookingContainer>
    )
  }
}

export default BookingPageLayout;
